<template>
  <div>
    <v-app-bar class="main-header-mobile" elevation="2" color="secondary" app>
      <div class="py-2 d-flex align-end">
        <router-link class="d-flex" to="/">
          <img :src="logo" class="logo" />
        </router-link>
      </div>
      <v-spacer />

      <v-menu
        v-model="menuSearch"
        min-width="100%"
        max-height="50px"
        content-class="menu-search-mobile"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="white" small icon>
            <v-icon
              v-text="menuSearch ? 'fas fa-times' : 'fas fa-search'"
              size="20"
            ></v-icon>
          </v-btn>
        </template>

        <Search @search="menuSearch = false" color="secondary lighten-1" />
      </v-menu>

      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        color="white"
        class="ml-2"
        small
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <div class="px-8 py-6 d-flex flex-column">
        <router-link to="/" class="d-flex">
          <img :src="logo" class="logo" />
        </router-link>
      </div>
      <v-divider></v-divider>
      <v-list-item-group v-model="current">
        <v-list>
          <v-list-item v-for="(route, i) in menu" :key="i" :to="route.to" link>
            <v-list-item-content>
              <v-list-item-title class="text-body-2 font-weight-bold">
                {{ route.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-group>
      <v-divider></v-divider>
      <v-list-item-group>
        <v-list>
          <v-list-item
            v-for="(route, i) in categories"
            :key="i"
            :to="route.to"
            link
          >
            <v-list-item-content>
              <v-list-item-title class="text-body-2 font-weight-bold">
                {{ route.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "@/components/utils";
import Search from "@/components/widgets/Search.vue";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
      menuSearch: false,
    };
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
    whatsappLink() {
      return getWhatsappLinkFromPhone(
        this.$rest("informations").item.whatsapp || ""
      );
    },
  },
  components: {
    Search,
  },
};
</script>

<style>
.main-header-mobile {
  z-index: 999 !important;
}
.main-header-mobile .logo {
  height: 42px;
  filter: brightness(0) invert(1);
}

.v-navigation-drawer__content .logo {
  width: 100%;
}
.v-navigation-drawer {
  z-index: 9999 !important;
}
.menu-search-mobile {
  margin-top: 14px;
  border-radius: 0;
}
</style>
